module.exports = __webpack_public_path__ + "static/brokenskiplink-caf2b6aabd2168567ae36d16da648752.png";